import React, {useEffect, useState} from 'react';
import {Link} from 'react-router-dom';
import './market.css';
import axios from 'axios';
import {isMobile} from 'react-device-detect';
import Panneltwo from './panneltwo';
import Mpanneltwo from './mpanneltwo';
import Pannelsam from './pannelsam';
import Evedoor from './eventdoor';

const Targets=()=>{
    const [turn, setturn] = useState(1);
    const [hackin, sethackin] = useState(false);
    const [clik, setclik] = useState(false);
    const [nomis, setnomis] = useState([]);
    const [tas, settas] = useState([]);
    const [insaz, setinsaz] = useState([]);
   
    // useEffect(()=>{
    //     if(hackin == true) return;
    //     if(clik == true) return;
        
    //         if(turn == 5){
    //             const jota = setTimeout(() => {
    //             document.querySelector(`.indo p:nth-child(${turn})`).classList.remove('power');
               
    //             document.querySelector(`.indo p:nth-child(1)`).classList.add('power');
    //             document.querySelector('.outdo').style.transform = 'translateY(0)';
    //             document.querySelector('.outdo').style.transition = 'all 0.3s ease';
    //             setturn(1);
    //             }, 3500);
    //            return ()=>{clearTimeout(jota);};
    //         }else{
    //         const jota = setTimeout(() => {
    //             document.querySelector(`.indo p:nth-child(${turn})`).classList.remove('power');
    //             document.querySelector(`.indo p:nth-child(${turn+1})`).classList.add('power');
    //             document.querySelector('.outdo').style.transform = `translateY(-${turn*300}px)`;
    //             document.querySelector('.outdo').style.transition = 'all 0.5s ease';
    //             setturn(turn+1);
    //         }, 3500);
    //            return ()=>{clearTimeout(jota);};
    //         };
    // }, [turn, hackin, clik]);

    // const fnax = async (signal) => {
    //     const { data : hooko } = await axios.get('/api/nomina', { signal });
    //     const data = {nomi : hooko.tensing, tasm : hooko.trt, insam : hooko.trend};
    //     return data;
    // };
    
    // const {isPending, data : last} = useQuery({queryKey:['kaza'], queryFn: ({signal})=>fnax(signal), 
    // placeholderData: keepPreviousData, staleTime: 1000 * 60 * 5, gcTime: 1000 * 60 * 30 });


    useEffect(()=>{
        const nomina = async ()=>{
            const tenz = await axios.get('/api/nomina').then(aiy=>{setnomis(aiy.data.tensing); settas(aiy.data.trt); setinsaz(aiy.data.trend); }).catch(err=>console.log("nothing"));
        };
        nomina();
        document.title = "돌파공모 - 인사이트";
    },[]);

    const konga=(e)=>{
        const zzi = e.currentTarget.getAttribute("value");
       
        setclik(true);
       
        document.querySelector(`.indo p:nth-child(${turn})`).classList.remove('power');
        document.querySelector(`.indo p:nth-child(${zzi})`).classList.add('power');
        document.querySelector('.outdo').style.transform = `translateY(-${(zzi-1)*400}px)`;
        document.querySelector('.outdo').style.transition = 'all 0.5s ease';
        setturn(parseInt(zzi));
    };
    const vonga=(e)=>{
        const zzi = e.currentTarget.getAttribute("value");
      
        setclik(true);
       
        document.querySelector(`.indo p:nth-child(${turn})`).classList.remove('power');
        document.querySelector(`.indo p:nth-child(${zzi})`).classList.add('power');
        document.querySelector('.outdo').style.transform = `translateY(-${(zzi-1)*300}px)`;
        document.querySelector('.outdo').style.transition = 'all 0.5s ease';
        setturn(parseInt(zzi));
    };
    const dasi=()=>{
        sethackin(!hackin);
    };
    const caca =()=>{
        setclik(false);
    };
  

    return(
    <>
    {isMobile ? <Mpanneltwo/> : <Panneltwo/>}
    {isMobile ? 
    <div className='mddo' style={{display:"block"}}>
        <div className='indo' onMouseOut={caca} style={{margin: "5px 20px 0"}}>
            <p className='power' onClick={konga} value="1">조회수</p>
            <p onClick={konga} value="2" style={{margin:"16px 20px"}}>타깃수</p>
            <p onClick={konga} value="3">인사이트</p>
            {/* <p onClick={konga} value="4">이벤트</p>
            <p onClick={konga} value="5">공학</p> */}
        </div>
        <div className='mwindo' onMouseOut={dasi} onMouseOver={dasi}>
        <div className='outdo'>
            <div className='mflowdo'>
                <p className='fcsc'><span className='kcsc'><img src={process.env.PUBLIC_URL+'/crown.png'} className='kcrow' /></span><span>조회수 순위</span></p>
                <ul style={{listStyle : 'none', paddingLeft : 0}}>
                {nomis.length>0 && nomis.map((cons,i)=><li className='lubt'>
                    <span className='mnubt'>{i+1}</span>
                    <Link to={`/ajo/${cons.id}`} state={cons} style={{textDecoration : "none"}} className='tenzname'>{cons.title}</Link>
                    <span className='kubt'>{cons.hit}</span>
                    </li>)}    
                </ul>
            </div>
            <div className='mflowdo'>
            <p className='fcsc'><span className='kcsc'><img src={process.env.PUBLIC_URL+'/hot.png'} className='kcrow' /></span><span>타깃 순위</span></p>
                <ul style={{listStyle : 'none', paddingLeft : 0}}>
                {tas.length>0 && tas.map((cons,i)=><li className='lubt'>
                    <span className='mnubt'>{i+1}</span>
                    <Link to={`/ajo/${cons.id}`} state={cons} style={{textDecoration : "none"}} className='tenzname'>{cons.title}</Link>
                    <span className='kubt'>{cons.targets}</span>
                    </li>)}    
                </ul>
            </div>
            <div className='mflowdo'>
            <p className='fcsc'><span className='kcsc'><img src={process.env.PUBLIC_URL+'/insight.png'} className='kcrow' /></span><span>인사이트</span></p>
                <ul style={{listStyle : 'none', paddingLeft : 0}}>
                {insaz.length>0 && insaz.map((cons,i)=><li className='lubt'>
                    <span className='mnubt'>{i+1}</span>
                    <Link to={`/mika/${cons.sun}`} state={cons} style={{textDecoration : "none"}} className='tenzname'>{cons.title}</Link>
                    <span className='kubt'>{cons.hit}</span>
                    </li>)}    
                </ul>
            </div>
        </div>
        </div>
    </div> :  <div className='ddo'>
        <div className='hitenz'>
        {/* <p className='fcsc'><span className='kcsc'><img src={process.env.PUBLIC_URL+'/insight.png'} className='kcrow' /></span><span>인사이트</span><span className='kcs'>추천</span><span>인사이트</span></p> */}
        <p className='fcs'><span className='kcsc'><img src={process.env.PUBLIC_URL+'/insight.png'} className='kcrow' /></span><span>인사이트</span>
            <span className='kcs2'><Link to='/mika' className='kcs3' ><span className='pcan2'>+</span></Link></span></p>
        <ul style={{listStyle : 'none', paddingLeft : 0}}>
            {insaz.length>0 && insaz.map((cons,i)=><li className='lubt'>
                <span className='numz'>{i+1}</span>
                <Link to={`/mika/${cons.sun}`} state={cons} style={{textDecoration : "none"}} className='tenzname'>{cons.title}</Link>
               
                </li>)}    
            </ul>

      
        </div>
        <div className='hitenz'>
            <p className='fcsc johui'><span className='kcsc'><img src={process.env.PUBLIC_URL+'/crown.png'} className='kcrow' /></span><span>조회수 순위</span></p>
            <ul style={{listStyle : 'none', paddingLeft : 0}}>
            {nomis.length>0 && nomis.map((cons,i)=><li className='lubt'>
                <span className='nubt'>{i+1}</span>
                <Link to={`/ajo/${cons.id}`} state={cons} style={{textDecoration : "none"}} className='tenzname'>{cons.title}</Link>
                <span className='kubt'>{cons.hit}</span>
                </li>)}    
            </ul>
        </div>
        <div className='hitenz'>
            <p className='fcsc tahui'><span className='kcsc'><img src={process.env.PUBLIC_URL+'/hot.png'} className='kcrow' /></span><span>타깃 순위</span></p>
            <ul style={{listStyle : 'none', paddingLeft : 0}}>
            {tas.length>0 && tas.map((cons,i)=><li className='lubt'>
                <span className='nubt'>{i+1}</span>
                <Link to={`/ajo/${cons.id}`} state={cons} style={{textDecoration : "none"}} className='tenzname'>{cons.title}</Link>
                <span className='kubt'>{cons.targets}</span>
                </li>)}    
            </ul>
        </div>
    </div> }
    <Evedoor/>
    <Pannelsam/>
    </>
    );
}

export default Targets;